import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { getNewbuildingId } from '../../selectors/newbuildingHeader';
import { trackPhoneShow } from '../../tracking/newbuilding';
import { ENewbuildingCallPlaceType } from '../../types/newbuildingHeader';
import { NewbuildingCallButtonContainer } from '../NewbuildingCallButton';

interface INewbuildingHeaderCallContainerProps {
  action?: string;
  placeType?: ENewbuildingCallPlaceType;
}

export const NewbuildingHeaderCallContainer = ({
  action = 'Open_jk_head_block',
  placeType = ENewbuildingCallPlaceType.NewbuildingHeaderInSerp,
}: INewbuildingHeaderCallContainerProps) => {
  const newbuildingId = useSelector(getNewbuildingId);

  const onShowPhoneClick = React.useCallback(() => {
    if (newbuildingId) {
      trackPhoneShow({ newbuildingId, action });
    }
  }, [newbuildingId, action]);

  return (
    <NewbuildingCallButtonContainer
      placeType={placeType}
      onShowPhoneClick={onShowPhoneClick}
      openContactsStyles={{ size: 'M' }}
      showPhoneStyles={{
        size: 'M',
        theme: 'fill_primary',
        beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" />,
      }}
    />
  );
};
